import React, { Component } from 'react';
import EndOfSyncModal from "Components/UserSettings/endOfSyncModal";

class EndOfSyncProcessUserLine extends Component {
    constructor(props) {
        super(props);

        this.state = {
            closed: true
        }
    }

    ChangeOpenState() {
        this.setState({
            closed: !this.state.closed
        });
    }

    render() {
        let { folderSyncInfos, lid, name } = this.props.syncUserInfo;

        let errorClass = '';

        for (let i = 0; i < folderSyncInfos.length; i++) {
            if (folderSyncInfos[i].isSuccess) continue;

            errorClass = 'error-line';
            break;
        }

        return (
            <div className={`smr-table-line ${errorClass}`}>
                <div className='end-of-sync-process-user-line-user-name'>
                    <div className="text-overflow-dotted" style={{ maxWidth: "70%", maxHeight: "40px" }}>{name}</div>
                    <button className={this.state.closed ? '' : 'blue-button'}
                        onClick={this.ChangeOpenState.bind(this)}>
                        {this.state.closed ? 'Подробнее' : 'Скрыть'}
                    </button>
                </div>
                {
                    this.state.closed ? '' : (<EndOfSyncModal userLid={lid} />)
                }
            </div>
        )
    }
}

export default EndOfSyncProcessUserLine;